import type { PricingTier, TokenPack } from '../../types/membership';
import { delay } from './storage';

// Exported so marketing pages (LandingPage, PricingPage) can render the same
// tiers synchronously without going through the async service.
export const MEMBERSHIP_TIERS: PricingTier[] = [
  {
    id: 'free_trial',
    name: 'Free Trial',
    monthlyPrice: 0,
    annualPrice: 0,
    monthlyTokens: 60,
    rolloverLimit: 0,
    bestFor: 'Exploring Teskedo',
    perks: ['21-day trial', '60 starter tokens', 'Earn up to 190 bonus tokens'],
  },
  {
    id: 'starter',
    name: 'Career Starter',
    monthlyPrice: 19,
    annualPrice: 190,
    monthlyTokens: 500,
    rolloverLimit: 800,
    bestFor: 'New job seekers',
    perks: ['500 tokens / month', 'Resume & cover letters', 'Job search tools'],
  },
  {
    id: 'professional',
    name: 'AI Professional',
    monthlyPrice: 49,
    annualPrice: 490,
    monthlyTokens: 2000,
    rolloverLimit: 3000,
    bestFor: 'Active switchers',
    popular: true,
    perks: ['2,000 tokens / month', 'AI recommendations', 'Application automation', 'Mentor matching'],
  },
  {
    id: 'transformer',
    name: 'Career Transformer',
    monthlyPrice: 99,
    annualPrice: 990,
    monthlyTokens: 5000,
    rolloverLimit: 8000,
    bestFor: 'Career changers',
    perks: ['5,000 tokens / month', '1:1 coaching', 'Priority job alerts', 'Interview prep library'],
  },
  {
    id: 'agency',
    name: 'Agency Builder',
    monthlyPrice: 199,
    annualPrice: 1990,
    monthlyTokens: 12000,
    rolloverLimit: 20000,
    bestFor: 'Coaches & agencies',
    perks: ['12,000 tokens / month', 'Multi-client workspace', 'White-label reports', 'Dedicated manager'],
  },
  {
    id: 'founder',
    name: 'Lifetime Founder',
    monthlyPrice: 997,
    annualPrice: 997,
    oneTime: true,
    monthlyTokens: 5000,
    rolloverLimit: Number.POSITIVE_INFINITY,
    bestFor: 'Power users',
    perks: ['Pay once, own forever', '5,000 tokens / month', 'Unlimited rollover', 'All future features'],
  },
];

export const TOKEN_PACKS: TokenPack[] = [
  { id: 'pack_100', tokens: 100, price: 9, bonusTokens: 0 },
  { id: 'pack_500', tokens: 500, price: 39, bonusTokens: 50 },
  { id: 'pack_1500', tokens: 1500, price: 99, bonusTokens: 250 },
  { id: 'pack_5000', tokens: 5000, price: 299, bonusTokens: 1000 },
];

export const pricingService = {
  async getTiers(): Promise<PricingTier[]> {
    return delay(MEMBERSHIP_TIERS);
  },
  getTierById(id: string): PricingTier | undefined {
    return MEMBERSHIP_TIERS.find((t) => t.id === id);
  },
  async getTokenPacks(): Promise<TokenPack[]> {
    return delay(TOKEN_PACKS);
  },
};
